import * as types from '../../lib/actionTypes.es6';
import {
  createWriteReducer,
  initialWriteState
} from '../../components/CommissionsShared/listReducerFactory.es6';

var saveReducer = createWriteReducer({
  request: types.UPDATE_COMMISSION_SETTINGS_REQUEST,
  success: types.UPDATE_COMMISSION_SETTINGS_SUCCESS,
  failure: types.UPDATE_COMMISSION_SETTINGS_FAILURE,
  reset: types.RESET_UPDATE_COMMISSION_SETTINGS
});

export function initialState() {
  return {
    data: null,
    loading: false,
    loaded: false,
    error: null,
    save: initialWriteState()
  };
}

export default function commissionSettingsReducer(state, action) {
  if (state === undefined) state = initialState();
  if (!action || !action.type) return state;

  var next = state;
  var save = saveReducer(state.save, action);
  if (save !== state.save) next = Object.assign({}, state, { save: save });

  switch (action.type) {
    case types.GET_COMMISSION_SETTINGS_REQUEST:
      return Object.assign({}, next, { loading: true, error: null });
    case types.GET_COMMISSION_SETTINGS_SUCCESS:
    case types.UPDATE_COMMISSION_SETTINGS_SUCCESS:
      return Object.assign({}, next, {
        data: action.payload || null,
        loading: false,
        loaded: true,
        error: null
      });
    case types.GET_COMMISSION_SETTINGS_FAILURE:
      return Object.assign({}, next, {
        loading: false,
        error: action.payload || {
          message: 'Could not load commission settings'
        }
      });
    default:
      return next;
  }
}
